import { SERVICE_LINKS } from '@/store/ServiceRegistry/linkedservices'

const EXECUTION_ID_FIELD = 'ExecutionId'

export function canIngest() {

}

export function getIngestionLink(file) {
  if (!file) return
  let metadata = file.Metadata
  if (!metadata) throw 'Need file metadata to view ingestion results'

  let meta = metadata.find(meta => meta.Field == EXECUTION_ID_FIELD)
  if (!meta) return

  const executionId = meta.FieldValue
  if (!executionId) return

  return {
    name: 'reviewingestionresults',
    params: {
      executionId,
    },
  }
}

export function getIngestionResultsLink(file) {
  if (!file) return
  let metadata = file.Metadata
  if (!metadata) throw 'Need file metadata to view ingestion results'

  let meta = metadata.find(meta => meta.Field == EXECUTION_ID_FIELD)
  if (!meta) return

  const executionId = meta.FieldValue
  if (!executionId) return

  return {
    name: 'reviewingestionresults',
    params: {
      executionId,
    },
  }
}

export const dataImporters = [
  { name: 'A125 Data', serviceLink: SERVICE_LINKS.A125_IMPORTER },
  { name: 'Hatfield EDD', serviceLink: SERVICE_LINKS.HATFIELD_EDD_INGESTION },
  { name: 'Ecosurvey EDD', serviceLink: SERVICE_LINKS.ECOSURVEY_EDD_INGESTION },
]

export const serviceKeys = [{
  key: 'newResults',
  displayName: 'measurement',
  color: 'info',
},
{
  key: 'newAnalytes',
  displayName: 'analyte',
  icon: 'format_color_fill',
  color: 'warning accent-1',
},
{
  key: 'newStations',
  displayName: 'station',
  icon: 'router',
  color: 'error lighten-1',
},
{
  key: 'newMediaTypes',
  displayName: 'media type',
  icon: 'art_track',
  color: 'success accent-1',
},
]

export const surveyDataKeys = [{
  key: 'NewSurveys',
  displayName: 'survey',
  color: 'info',
},
{
  key: 'NewSpecimences',
  displayName: 'specimence',
  icon: 'format_color_fill',
  color: 'warning accent-1',
},
{
  key: 'NewSurveyLocations',
  displayName: 'survey location',
  icon: 'router',
  color: 'error lighten-1',
},
]

export function prettyPrintServiceName(serviceName) {
  let names = serviceName.split('.')

  try {
    let dataType = names[names.length - 1]
    return dataType
  } catch (error) {
    console.error(error)
  }
}

const ingestionParams = `
<div>Are you sure you want to reingest this data?</div>
<div class="mt-3">The following will occur: </div>
<ol>
<li>A new version of the data file will be created to save changes in your data and metadata</li>
<li>The new version of the data file will be validated against the latest ingestion configuration</li>
<li>If validation was successful, the data will be ingested </li>
</ol>
<div class="mt-3"> <strong>Note:</strong> Already ingested data will be replicated. </div>
`

export const reingestConfirmParams = {
  text: ingestionParams,
  title: 'Ingest data',
  confirmText: 'Ingest',
  cancelText: 'Cancel',
  color: 'success',
  icon: 'publish',
}

export const autodetectConfirmParams = {
  text: `
  <div>Are you sure you want to auto-detect the file type?</div>
  <div>If this file has already been ingested, a new version of this file will be created and used instead.</div>
  `,
  title: 'Auto-detect file type',
  confirmText: 'Submit',
  cancelText: 'Cancel',
  color: 'success',
  icon: 'preview',
}

export const deleteConfirmParams = {
  text: `
  <div>Are you sure you want to delete the file?</div>
  <div>File can be restored from recycle bin after being deleted.</div>
  `,
  title: 'Delete file',
  confirmText: 'Submit',
  cancelText: 'Cancel',
  color: 'success',
  icon: 'preview',
}

export const restoreConfirmParams = {
  text: `
  <div>Are you sure you want to restore the file?</div>  
  `,
  title: 'Restore file',
  confirmText: 'Submit',
  cancelText: 'Cancel',
  color: 'success',
  icon: 'preview',
}